






















import Vue from "vue"

function causeAsyncError(): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    setTimeout(() => {
      reject(new Error("Async call blew up"))
    })
  })
}

export default Vue.extend({
  methods: {
    throwError() {
      throw new Error("Directly thrown error")
    },
    async throwAsyncError() {
      await causeAsyncError()
    },
    throwSetTimeoutError() {
      setTimeout(() => {
        throw new Error("Error in setTimeout")
      })
    },
    throwString() {
      throw "Naked Error string"
    },
  },
})
